import { render } from "./SelfRequest.vue?vue&type=template&id=4df63082"
import script from "./SelfRequest.vue?vue&type=script&lang=js"
export * from "./SelfRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__